"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateAvailabilityInterval = void 0;
const luxon_1 = require("luxon");
const constants_1 = require("../constants");
const validateAvailabilityInterval = (interval, limit) => {
    const { dateFrom, dateTo } = interval;
    const { days } = luxon_1.DateTime.fromISO(dateTo).diff(luxon_1.DateTime.fromISO(dateFrom), 'days');
    if (days > (limit || constants_1.MAX_AVAILABILITY_INTERVAL))
        return false;
    return true;
};
exports.validateAvailabilityInterval = validateAvailabilityInterval;
